import { useQuery } from '@tanstack/react-query';

import { listApprovalRequests } from '~/services/LuxLoyaltyService';

import type { ApprovalRequestStatus } from '~/types/loyaltyContract';

import { claimsQueryKeys } from './claimsQueryKeys';

const DEFAULT_PAGE_SIZE = 25;

export function useGetApprovalRequests(
  campaignId: string | null,
  status?: ApprovalRequestStatus,
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE,
) {
  return useQuery({
    queryKey: claimsQueryKeys.approvalRequests(campaignId ?? '', status, page, pageSize),
    queryFn: ({ signal }) =>
      listApprovalRequests(
        campaignId!,
        { ...(status ? { status } : {}), limit: String(pageSize), offset: String(page * pageSize) },
        { signal },
      ),
    select: (data) => data.result,
    enabled: !!campaignId,
  });
}
